import Swal from 'sweetalert2';

import './styles.css'

export const Toast = (title, icon = 'success') => {
  Swal.fire(
    {
      customClass: {
        container: 'toast-notify',
      },
      icon,
      position: 'bottom-end',
      timer: 5000,
      title,
      toast: true,
      showConfirmButton: false,
    }
  )
}